var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatDefault = function SvgChatDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    fillRule: "evenodd",
    d: "M.334 6.999a6.667 6.667 0 1 1 5.725 6.6 277.92 277.92 0 0 0-1.236-.17l-.022-.003H4.792l-.093-.008a.365.365 0 0 0-.02-.001h-.112c-.08.001-.175.008-.426.026l-1.46.104a8.756 8.756 0 0 1-.702.033 1.601 1.601 0 0 1-.678-.137 1.566 1.566 0 0 1-.744-.745 1.6 1.6 0 0 1-.138-.677c-.003-.199.014-.438.033-.702l.105-1.46c.018-.252.024-.347.025-.426V9.3l-.008-.093v-.002l-.001-.006-.002-.022a6.718 6.718 0 0 1-.237-2.178Zm4-2a.667.667 0 1 0 0 1.333h5.333a.667.667 0 0 0 0-1.333H4.334Zm0 2.666a.667.667 0 0 0 0 1.334h2.667a.667.667 0 0 0 0-1.334H4.334Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatDefault);
export default ForwardRef;